import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProductUsageGuides } from "../../constants";
import { UsageGuide } from "../../productUsageGuides.types";
import { UpdateUsageGuideFaqItemRequestBody } from "./updateUsageGuideFaqItem.types";

export const requestUpdateUsageGuideFaqItem = async ({
  id,
  ...body
}: UpdateUsageGuideFaqItemRequestBody): Promise<UsageGuide> => {
  return await instance.patch(
    buildUrl(ApiRoutesProductUsageGuides.FaqItems, id),
    body
  );
};
